class StorageService {
  constructor() {
    //  Update the storageVersion if storage changes and does
    //  not support the current stored storage. This will force all clients to login again
    const storageVersion = '4.1';
    let currentStorageVersion;

    try {
      currentStorageVersion = this.get('storageVersion');
    } catch (e) {
      currentStorageVersion = null;
    }

    if (!currentStorageVersion || currentStorageVersion !== storageVersion) {
      this.clear();

      this.set('storageVersion', storageVersion);
    }
  }

  get(key: string) {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue && JSON.parse(storedValue).value;
    } catch (e) {
      return null;
    }
  }

  remove(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      return null;
    }
  }

  set<T>(key: string, value: T) {
    try {
      localStorage.setItem(key, JSON.stringify({ value }));
    } catch (e) {
      return null;
    }
  }

  clear() {
    try {
      const diValue = localStorage.getItem('di');
      const dashboardColumns = localStorage.getItem('dashboardColumns');
      const language = localStorage.getItem('language');

      localStorage.clear();
      if (diValue) {
        localStorage.setItem('di', diValue);
      }
      if (dashboardColumns) {
        localStorage.setItem('dashboardColumns', dashboardColumns);
      }
      if (language) {
        localStorage.setItem('language', language);
      }
    } catch (e) {
      return null;
    }
  }
}

export default new StorageService();
